import React from 'react';

import Recover from '@Components/login/recover';

const RecoverPage = props => (
  <Recover {...props} />
);

export default RecoverPage;